export const SET_INITIAL_DATA = 'SET_INITIAL_DATA'
export const SET_DASHBOARD_DATA_LOADED_STATE = 'SET_DASHBOARD_DATA_LOADED_STATE'
export const DELETE_INVOICE = 'DELETE_INVOICE'
export const UPDATE_INVOICE_STATUS = 'UPDATE_INVOICE_STATUS'
export const DELETE_ESTIMATE = 'DELETE_ESTIMATE'
export const UPDATE_ESTIMATE_STATUS = 'UPDATE_ESTIMATE_STATUS'
